// src/resources/messages.js
import * as React from 'react';
import {
    List,
    Datagrid,
    TextField,
    NumberField,
    BooleanField,
    DateField,
    
    SimpleForm,
    NumberInput,
    BooleanInput,
    Filter,
    SelectInput,
    
} from 'react-admin';

// Компонент фильтров
const MessagesFilter = (props) => {
    
    
    return (
        <Filter {...props} >
            <NumberInput 
                source="chat_id" 
                label="Chat ID" 
                alwaysOn 
                style={{ marginRight: 16 }}
            />
        </Filter>
    );
};

// Список голосов
export const MessagesList = (props) => (
    <List 
        {...props} 
        filters={<MessagesFilter />}
        perPage={25}
        sort={{ field: 'id', order: 'DESC' }}
        exporter={false}
    >
        <Datagrid>
            <NumberField source="id" />
            <TextField source="time" label="Время"/>
            <NumberField source="chat_id" label="ID чата"/>
            <TextField source="sender_type" label="Отправитель"/>
            <TextField source="text" label="Текст"/>
            
        </Datagrid>
    </List>
);


export default {
    list: MessagesList
};